import type { RefObject } from 'react';

interface PageWipeRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PageWipeRefs,
): void {
  timeline.fromTo(
    elementRef.current,
    { scaleY: 0, transformOrigin: 'center bottom' },
    {
      scaleY: 1,
      duration: 0.5,
      transformOrigin: 'center bottom',
      ease: 'Quad.easeIn',
    },
  );
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: PageWipeRefs,
): void {
  timeline.fromTo(
    elementRef.current,
    { transformOrigin: 'center top', scaleY: 1 },
    { transformOrigin: 'center top', scaleY: 0, duration: 0.5, ease: 'Quad.easeOut' },
    0,
  );
}
